import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import '../../styles/p25.css';

const API = process.env.REACT_APP_BACKEND_URL;
const ax = (m, url, data) => axios({ method: m, url: `${API}${url}`, data, withCredentials: true });

const Buyers25Tab = () => {
  const [buyers, setBuyers] = useState([]);
  const [search, setSearch] = useState('');
  const [flt, setFlt] = useState('');
  const [detail, setDetail] = useState(null);
  const [tpl, setTpl] = useState(null);
  const [appHtml, setAppHtml] = useState('');
  const [msg, setMsg] = useState('');
  const [grantEmail, setGrantEmail] = useState('');
  const [blast, setBlast] = useState(null);

  const load = useCallback(() => {
    ax('get', `/api/admin/25/buyers?search=${encodeURIComponent(search)}&flt=${flt}`)
      .then(r => { setBuyers(r.data.buyers); setMsg(m => (m === 'Failed to load buyers' ? '' : m)); })
      .catch(() => setMsg('Failed to load buyers'));
  }, [search, flt]);
  useEffect(() => { load(); }, [load]);

  const action = async (pi, a) => {
    setMsg('');
    try {
      await ax('post', `/api/admin/25/buyers/${pi}/action`, { action: a });
      setMsg(`${a} done`);
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Action failed');
    }
    load();
  };
  const openDetail = (pi) => ax('get', `/api/admin/25/buyers/${pi}`).then(r => setDetail(r.data));
  const loadTpl = () => ax('get', '/api/admin/25/templates').then(r => setTpl(r.data));
  const saveTpl = (key) => ax('put', `/api/admin/25/templates/${key}`, tpl[key]).then(() => setMsg('Template saved'))
    .catch(e => setMsg(e.response?.data?.detail || 'Template save failed'));
  const uploadApp = () => ax('post', '/api/admin/25/app', { html: appHtml }).then(() => { setMsg('Workout app replaced'); setAppHtml(''); });
  const rollback = () => ax('post', '/api/admin/25/app/rollback').then(() => setMsg('Rolled back')).catch(() => setMsg('No previous version'));
  const reconcile = () => ax('post', '/api/admin/25/reconcile').then(r => { setMsg(`Reconciled ${r.data.fulfilled} missed purchases`); load(); });
  const grant = () => ax('post', '/api/admin/25/grant', { email: grantEmail, send_email: true })
    .then(r => { setMsg(r.data.existing ? 'Already has access' : `Granted. Link: ${r.data.link || 'emailed'}`); setGrantEmail(''); load(); });
  const checkBlast = () => ax('get', '/api/admin/25/launch-blast').then(r => setBlast(r.data))
    .catch(e => setMsg(e.response?.data?.detail || 'Could not load waitlist status'));
  const sendBlast = () => {
    if (!window.confirm(`Send the launch email to ${blast.pending} waitlist subscribers? This sends real email and each person only ever gets it once.`)) return;
    ax('post', '/api/admin/25/launch-blast').then(r => { setMsg(`Launch blast started for ${r.data.started} people — refresh status to follow progress`); checkBlast(); })
      .catch(e => setMsg(e.response?.data?.detail || 'Launch blast failed to start'));
  };

  const fmt = (d) => d ? new Date(d).toLocaleString() : '—';

  return (
    <div className="tab-content" data-testid="buyers25-tab">
      <div className="tab-header"><h2>25 for 25 Buyers</h2></div>
      {msg && <p style={{ background: '#FFF3CD', padding: '8px 12px', fontSize: 13 }} data-testid="buyers25-msg">{msg}</p>}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
        <input placeholder="Search email or name" value={search} onChange={e => setSearch(e.target.value)}
          style={{ padding: 8, border: '1px solid #ccc' }} data-testid="buyers25-search" />
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
          <input type="checkbox" checked={flt === 'notopened48'} onChange={e => setFlt(e.target.checked ? 'notopened48' : '')} data-testid="buyers25-filter-48h" />
          Not opened after 48h
        </label>
        <a href={`${API}/api/admin/25/export`} style={{ fontSize: 13, alignSelf: 'center' }} data-testid="buyers25-csv">CSV export</a>
        <button onClick={reconcile} style={{ fontSize: 13 }} data-testid="buyers25-reconcile">Reconcile missed purchases</button>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input placeholder="Manual grant: email" value={grantEmail} onChange={e => setGrantEmail(e.target.value)}
          style={{ padding: 8, border: '1px solid #ccc' }} data-testid="buyers25-grant-email" />
        <button onClick={grant} disabled={!grantEmail} data-testid="buyers25-grant-btn">Grant access + email link</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
          <thead><tr style={{ textAlign: 'left', borderBottom: '2px solid #333' }}>
            <th>Email</th><th>Name</th><th>Purchased</th><th>$</th><th>Status</th><th>First opened</th>
            <th>Last opened</th><th>Onb.</th><th>GCF✓</th><th>WW✓</th><th>Airtable</th><th>Actions</th>
          </tr></thead>
          <tbody>
            {buyers.map(b => (
              <tr key={b.pi} style={{ borderBottom: '1px solid #ddd' }} data-testid={`buyer-row-${b.email}`}>
                <td style={{ cursor: 'pointer', color: '#E8432A' }} onClick={() => openDetail(b.pi)}>{b.email}</td>
                <td>{b.name || '—'}</td><td>{fmt(b.purchase_date)}</td><td>{b.amount}</td>
                <td>{b.status}</td><td>{fmt(b.first_opened)}</td><td>{fmt(b.last_opened)}</td>
                <td>{b.onboarding_complete ? 'Y' : 'N'}</td><td>{b.consent_gcf ? 'Y' : 'N'}</td><td>{b.consent_ww ? 'Y' : 'N'}</td>
                <td>{b.airtable}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button onClick={() => action(b.pi, 'resend_link')} title="Resend access link">Link</button>{' '}
                  <button onClick={() => action(b.pi, 'resend_e1')} title="Resend E1">E1</button>{' '}
                  {b.status === 'active'
                    ? <button onClick={() => action(b.pi, 'revoke')}>Revoke</button>
                    : <button onClick={() => action(b.pi, 'reactivate')}>Reactivate</button>}{' '}
                  {b.airtable !== 'ok' && <button onClick={() => action(b.pi, 'retry_airtable')}>Retry AT</button>}
                </td>
              </tr>
            ))}
            {!buyers.length && <tr><td colSpan="12" style={{ padding: 16, color: '#888' }}>No buyers yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {detail && (
        <div style={{ marginTop: 20, background: '#fff', border: '1px solid #ddd', padding: 16 }} data-testid="buyer-detail">
          <h3>{detail.email} <button style={{ float: 'right' }} onClick={() => setDetail(null)}>Close</button></h3>
          <p style={{ fontSize: 13 }}><b>Acknowledgement:</b> "{detail.ack?.text}" — {fmt(detail.ack?.ts)} from IP {detail.ack?.ip}</p>
          <p style={{ fontSize: 13 }}><b>Airtable:</b> {detail.airtable?.status} {detail.airtable?.last_error && `— ${detail.airtable.last_error}`}</p>
          <h4>Email log</h4>
          <table style={{ fontSize: 13, width: '100%' }}>
            <thead><tr style={{ textAlign: 'left' }}><th>Type</th><th>Sent</th><th>Result</th><th>Detail</th></tr></thead>
            <tbody>{(detail.emails || []).map((e, i) => (
              <tr key={i}><td>{e.type}</td><td>{fmt(e.sent_at)}</td><td>{e.status}</td><td>{e.status === 'failed' ? e.detail : e.detail?.slice(0, 20)}</td></tr>
            ))}</tbody>
          </table>
        </div>
      )}

      <div style={{ marginTop: 28 }}>
        <h3>Email template (E1) {!tpl && <button onClick={loadTpl} data-testid="buyers25-load-tpl">Edit</button>}</h3>
        {tpl && (
          <div style={{ maxWidth: 640 }}>
            <input style={{ width: '100%', padding: 8, marginBottom: 8 }} value={tpl.E1.subject}
              onChange={e => setTpl({ ...tpl, E1: { ...tpl.E1, subject: e.target.value } })} data-testid="tpl-subject" />
            <textarea style={{ width: '100%', padding: 8, minHeight: 160 }} value={tpl.E1.body}
              onChange={e => setTpl({ ...tpl, E1: { ...tpl.E1, body: e.target.value } })} data-testid="tpl-body" />
            <p style={{ fontSize: 12, color: '#888' }}>Merge fields: {'{{FirstName}}'} and {'{{AccessLink}}'}</p>
            <button onClick={() => saveTpl('E1')} data-testid="tpl-save">Save template</button>
          </div>
        )}
      </div>

      <div style={{ marginTop: 28 }}>
        <h3>Waitlist launch blast</h3>
        <p style={{ fontSize: 13, color: '#666' }}>One-time launch announcement to everyone on the 25 for 25 waitlist. Skips buyers and anyone already emailed.</p>
        {tpl?.LAUNCH && (
          <div style={{ maxWidth: 640, marginBottom: 10 }}>
            <input style={{ width: '100%', padding: 8, marginBottom: 8 }} value={tpl.LAUNCH.subject}
              onChange={e => setTpl({ ...tpl, LAUNCH: { ...tpl.LAUNCH, subject: e.target.value } })} data-testid="launch-tpl-subject" />
            <textarea style={{ width: '100%', padding: 8, minHeight: 160 }} value={tpl.LAUNCH.body}
              onChange={e => setTpl({ ...tpl, LAUNCH: { ...tpl.LAUNCH, body: e.target.value } })} data-testid="launch-tpl-body" />
            <p style={{ fontSize: 12, color: '#888' }}>Merge fields: {'{{FirstName}}'} and {'{{AccessLink}}'} (the buy link)</p>
            <button onClick={() => saveTpl('LAUNCH')} data-testid="launch-tpl-save">Save launch template</button>
          </div>
        )}
        {!tpl && <p style={{ fontSize: 12, color: '#888' }}>Click "Edit" above to review the launch email before sending.</p>}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button onClick={checkBlast} data-testid="launch-blast-check">Check waitlist</button>
          {blast && (
            <>
              <span style={{ fontSize: 13 }} data-testid="launch-blast-counts">{blast.pending} to send · {blast.sent} sent · {blast.failed} failed</span>
              <button onClick={sendBlast} disabled={!blast.pending} data-testid="launch-blast-send">
                Send launch email to {blast.pending} people
              </button>
            </>
          )}
        </div>
      </div>

      <div style={{ marginTop: 28 }}>
        <h3>Replace workout app</h3>
        <textarea style={{ width: '100%', maxWidth: 640, minHeight: 120, padding: 8 }} placeholder="Paste the full HTML of the workout app here"
          value={appHtml} onChange={e => setAppHtml(e.target.value)} data-testid="app25-html" />
        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button onClick={uploadApp} disabled={!appHtml} data-testid="app25-upload">Replace app</button>
          <button onClick={rollback} data-testid="app25-rollback">Rollback to previous</button>
        </div>
      </div>
    </div>
  );
};

export default Buyers25Tab;
